import { render, staticRenderFns } from "./StepNavigation.vue?vue&type=template&id=2876ee0c&scoped=true&"
import script from "./StepNavigation.vue?vue&type=script&lang=js&"
export * from "./StepNavigation.vue?vue&type=script&lang=js&"
import style0 from "./StepNavigation.vue?vue&type=style&index=0&id=2876ee0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2876ee0c",
  null
  
)

export default component.exports